// extracted by mini-css-extract-plugin
module.exports = {"main":"DocumentEditorPage_main_2pe19","titleContainer":"DocumentEditorPage_titleContainer_1w5yB","spinAround":"DocumentEditorPage_spinAround_rf8WF"};